import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { getFilterItems, getIsLoaded, getIsLoading } from '../store/filters/filters.selectors';
import { getHashId, getIsDonation } from '../store/settings/settings.selectors';
import { setFilter } from '../store/products/products.actions';
import { getCountryId } from '../store/products/products.selectors';

export default (filterOptions, loadAction, onChangeFilter = () => {}) => {
  const dispatch = useDispatch();

  const hashId = useSelector(getHashId);
  const isDonation = useSelector(getIsDonation);
  const countryId = useSelector(getCountryId);

  const isLoading = useSelector(getIsLoading(filterOptions.key), shallowEqual);
  const isLoaded = useSelector(getIsLoaded(filterOptions.key), shallowEqual);
  const options = useSelector(getFilterItems(filterOptions.key), shallowEqual);

  const openFilter = useCallback(() => {
    if (hashId && !isLoaded) {
      dispatch(loadAction({ hashId, isDonation, countryId }));
    }
  }, [isDonation, hashId, countryId, loadAction, dispatch, isLoaded]);

  const changeFilter = useCallback(
    (name, selectedValues, option, checked) => {
      dispatch(setFilter({ key: name, items: selectedValues }));
      onChangeFilter(name, option, checked);
    },
    [dispatch, onChangeFilter],
  );

  return {
    isLoading,
    isLoaded,
    options,
    openFilter,
    changeFilter,
  };
};
